/* eslint-disable @typescript-eslint/no-unused-vars */
const tokenKey = "token";

export function getToken(key?: string) {
  try {
    return localStorage.getItem(key ? key : tokenKey);
  } catch (e) {
    return;
  }
}

export function setToken(token: string, key?: string) {
  try {
    return localStorage.setItem(key ? key : tokenKey, token);
  } catch (e) {
    return;
  }
}

export function removeToken() {
  try {
    return localStorage.removeItem(tokenKey);
  } catch (e) {
    return;
  }
}
